import BigNumber from 'bignumber.js';
import { calculateTaxDetail } from 'helpers/Function/CalculateTaxDetail';
import { SystemMsgs } from 'helpers/Messages/SystemMsg';
import { amtNumStr } from 'helpers/StringNumberFunction/numFormatter';
import { CommonYupValidation } from 'helpers/YupSchema/yup';
import * as yup from 'yup';
import { ResetErrMan } from '../GLDialog/ClaimType';
import { format } from 'date-fns';

// export const viewClaimWBSWithRevenue = (wbsID)
export const prepareTaxCalculationData = (selectedTax: any) => {
  if (selectedTax?.taxSchemeDetails?.length > 0) {
    if (!selectedTax?.taxSchemeDetails[0]?.taxSchemeDetailItems?.length) {
      return [];
    }

    const taxSchemeDetail = selectedTax?.taxSchemeDetails?.sort((a, b) =>
      a?.effectiveDate < b?.effectiveDate ? 1 : -1,
    )[0];

    const taxRate = taxSchemeDetail?.taxSchemeDetailItems?.map(
      e =>
        e?.tax?.taxDetail?.sort((a, b) =>
          a?.effectiveDate < b?.effectiveDate ? 1 : -1,
        )[0]?.rate,
    );

    return taxSchemeDetail?.taxSchemeDetailItems?.map((item, itemIndex) => ({
      taxId: item?.taxId,
      taxSchemeId: taxSchemeDetail?.taxSchemeId,
      taxSchemeDetailId: taxSchemeDetail?.id,
      seqNo: item?.seqNo,
      taxOnSeq: item?.taxOnSeq || [],
      computeMethod:
        item?.computeMethod === 'TAX_ON_GROSS'
          ? 'Tax_On_Gross'
          : 'Tax_On_Taxed_Price',
      taxRate: taxRate[itemIndex],
      taxCode: item?.tax?.code,
    }));
  }
};

export const taxRatePerc = (taxDetails: any) => {
  let taxData = prepareTaxCalculationData(taxDetails) ?? [];
  return taxData[0]?.taxRate ?? 0;
};

export const calculateTaxFromState = (
  selectedTax: any,
  amount: number,
  taxSchemeDetails,
) => {
  if (!!taxSchemeDetails?.taxSchemeDetails) {
    const taxData = prepareTaxCalculationData(taxSchemeDetails);
    const isExclusive = Boolean(selectedTax?.isExclusive);

    return calculateTaxDetail(taxData, amount, isExclusive);
  }
};

export const voClaimWbsArr = (
  data,
  type: 'subconTrade' | 'conWbs',
  obj: any[],
  previousVOCertifiedAmt: any[],
  taxScheme: any,
  RequiredFieldTax: any,
) => {
  data?.map(v => {
    const getPreviousApproveVOAmt =
      type === 'conWbs'
        ? previousVOCertifiedAmt?.find(we => we?.ID === v?.ID)?.previousAmt
            ?.previousApproveAmt ?? 0
        : type === 'subconTrade'
        ? previousVOCertifiedAmt?.find(we => we?.ID === v)?.previousTradeVoAmt
            ?.previousApproveAmt ?? 0
        : 0;
    const taxSchemeDetails =
      taxScheme?.find(tax => tax?.id === v?.taxSchemeID) ?? null;
    const taxSchemeDetailsCalc = calculateTaxFromState(
      taxSchemeDetails,
      v?.currSubmissionAmt,
      taxSchemeDetails,
    )?.taxDetails;

    const taxSchemeDetailsInput = taxSchemeDetailsCalc.map(x => {
      return {
        taxID: x?.taxId,
        taxSchemeID: x?.taxSchemeId,
        taxSchemeDetailID: x?.taxSchemeDetailId,
        taxRate: x?.TaxRate,
        taxAmount: x?.TaxAmount,
        ...RequiredFieldTax,
      };
    });

    obj.push({
      ...(type === 'conWbs'
        ? { contractVORevenueWbsID: v?.ID }
        : { subcontractVOCostWbsID: v?.ID }),
      currentSubmission: v?.currentSubmissionAmt,
      retentionAmt: v?.retentionAmt,
      taxAmount: v?.taxAmount,
      previousVOClaimAmt: getPreviousApproveVOAmt,
      taxSchemeDetailsInput: taxSchemeDetailsInput,
    });
  });

  return obj;
};

export const voClaimObjectAssignment = (
  data,
  obj: any[],
  type: 'subconTrade' | 'conWbs' | 'subcon' | 'con',
  previousVOCertifiedAmt: any[],
  taxSchemeDetails: any,
  RequiredFieldTax: any,
) => {
  Object.keys(data)?.map(v => {
    const getPreviousApproveVOAmt =
      type === 'conWbs'
        ? previousVOCertifiedAmt?.find(we => we?.ID === v)?.previousAmt
            ?.previousApproveAmt ?? 0
        : type === 'con'
        ? previousVOCertifiedAmt?.find(we => we?.ID === v)?.contractClaimVOAlloc
            ?.previousApproveAmt ?? 0
        : type === 'subconTrade'
        ? previousVOCertifiedAmt?.find(we => we?.ID === v)?.previousTradeVoAmt
            ?.previousApproveAmt ?? 0
        : previousVOCertifiedAmt?.find(we => we?.ID === v)
            ?.subcontractClaimVOAlloc?.previousApproveAmt ?? 0;

    const taxSchemeDetailsCalc = calculateTaxFromState(
      taxSchemeDetails,
      toFloatCond(data[v]),
      taxSchemeDetails,
    )?.taxDetails;

    const taxSchemeDetailsInput = taxSchemeDetailsCalc.map(v => {
      return {
        taxID: v?.taxId,
        taxSchemeID: v?.taxSchemeId,
        taxSchemeDetailID: v?.taxSchemeDetailId,
        taxRate: v?.TaxRate,
        taxAmount: v?.TaxAmount,
        ...RequiredFieldTax,
      };
    });

    obj.push({
      ...(type === 'subconTrade'
        ? { subcontractVOCostWbsID: v }
        : type === 'conWbs'
        ? { contractVORevenueWbsID: v }
        : type === 'subcon'
        ? { subcontractVOID: v }
        : { contractVOID: v }),
      currentSubmission: toFloatCond(data[v]),
      previousVOClaimAmt: getPreviousApproveVOAmt,
      taxSchemeDetailsInput: taxSchemeDetailsInput,
    });
  });

  return obj;
};

export const calcMosDayworkTax = (
  currSubmission: number,
  taxSchemeData: any[],
  taxSchemeID: string,
) => {
  const taxSchemeDetails = taxSchemeData?.find(el => el?.id === taxSchemeID);
  return calTaxAmount(currSubmission, taxSchemeDetails);
};

export const calTaxAmount = (totalAmt: number, taxSchemeDetails) => {
  let taxAmount = 0;

  const taxSchemeDetailsCalc =
    calculateTaxFromState(taxSchemeDetails, totalAmt ?? 0, taxSchemeDetails)
      ?.taxDetails ?? [];

  const taxSchemeDetailsInput: any[] = taxSchemeDetailsCalc.map(v => {
    return {
      taxID: v?.taxId,
      taxSchemeID: v?.taxSchemeId,
      taxSchemeDetailID: v?.taxSchemeDetailId,
      taxRate: v?.TaxRate,
      taxAmount: v?.TaxAmount,
    };
  });

  taxAmount = taxSchemeDetailsInput[0]?.taxAmount ?? 0;

  return taxAmount;
};

export const resetErrorManual = ({
  ID,
  errorObj,
  setErrorObj,
}: ResetErrMan) => {
  if (!!errorObj[ID]) {
    setErrorObj(
      Object?.keys(errorObj)
        ?.filter(key => {
          return !key?.includes(ID);
        })
        ?.reduce((curr, key) => {
          return Object?.assign(curr, {
            [key]: errorObj[key],
          });
        }, {}),
    );
  }
};

export const reduceVOClaim = (watch, vo, compareID) => {
  return (
    watch?.find(watchD => watchD[vo] === compareID)?.currentSubmission ?? 0
  );
};

export const reduceVOClaimWBS = (watch, vo, compareID, type) => {
  if (type == 'submission') {
    return (
      watch?.find(watchD => watchD[vo] === compareID)?.currentSubmission ?? 0
    );
  } else if (type == 'retention') {
    return watch?.find(watchD => watchD[vo] === compareID)?.retentionAmt ?? 0;
  } else {
    return watch?.find(watchD => watchD[vo] === compareID)?.taxAmount ?? 0;
  }
};

export const simplePlus = data => {
  return new BigNumber(data.data1 || 0).plus(data.data2 || 0).toNumber();
};

export const simpleMinus = data => {
  return new BigNumber(data.data1 || 0).minus(data.data2 || 0).toNumber();
};

export const minusOrZero = data => {
  let retVal = new BigNumber(data.data1 || 0).minus(data.data2 || 0).toNumber();
  if (retVal <= 0) {
    return 0;
  } else {
    return retVal;
  }
};

export const netClaim = data => {
  return new BigNumber(data.currAmt || 0)
    .plus(data.VOClaim || 0)
    .minus(data.prevClaim || 0)
    .minus(data.prevVo || 0)
    .toNumber();
};

export const netMOS = data => {
  return new BigNumber(data.currMOS || 0).minus(data.prevMOS || 0).toNumber();
};

export const gTotal = data => {
  return new BigNumber(data.netClaim || 0)
    .plus(data.netMOS || 0)
    .toNumber()
    .toFixed(2);
};

export const ret = data => {
  let reMaxRet = new BigNumber(data.maxRet);
  let reSumRet = new BigNumber(data.prevRetSum);
  let ret = new BigNumber(data.gTotal || 0).times(data.progRet || 1).div(100);

  let currTotalRet = new BigNumber(ret).plus(reSumRet.toNumber());

  if (reSumRet.gte(reMaxRet)) {
    return 0;
  } else if (currTotalRet.gt(reMaxRet) && reSumRet.lt(reMaxRet)) {
    return reMaxRet.minus(reSumRet).toNumber();
  } else {
    return new BigNumber(data.gTotal || 0)
      .times(data.progRet || 1)
      .div(100)
      .toNumber();
  }

  // else {
  //   return new BigNumber(data.gTotal || 0)
  //     .times(data.progRet || 1)
  //     .div(100)
  //     .toNumber();
  // }
};

export const totalRetentionSST = (maxRet, prevRetSum, ret, excludeVO) => {
  let reMaxRet = new BigNumber(maxRet);
  let reSumRet = new BigNumber(prevRetSum);
  let subRet = new BigNumber(ret?.submissionRetention);
  let voRet = new BigNumber(ret?.voRetention);
  let mosRet = new BigNumber(ret?.mosRetention);

  let currTotalRet = excludeVO
    ? new BigNumber(subRet).plus(mosRet)
    : new BigNumber(subRet).plus(mosRet).plus(voRet);
    
  return currTotalRet.toNumber(); //CX5240

  //prevRetention > maxRetention
  // if (reSumRet.gte(reMaxRet)) {
  //   return 0;
  // } else if (currTotalRet.gt(reMaxRet) && reSumRet.lt(reMaxRet)) {
  //   return reMaxRet.minus(reSumRet).toNumber();
  // } else {
  //   return currTotalRet.toNumber();
  // }
};

export const calcRet = data => {
  return handleRetAmt(data.maxRet || 0, data.prevRetSum || 0, data.ret || 0);
};

export const handleRetAmt = (maxRet, sumPrevRet, retention) => {
  let returnVal = new BigNumber(0);
  let reMaxRet = new BigNumber(maxRet);
  let reSumRet = new BigNumber(sumPrevRet);
  let ret = new BigNumber(retention);

  if (reSumRet.gte(reMaxRet)) {
    return 0;
  } else if (ret.lt(0)) {
    // NOTE: im not even sure whether this applies to all
    // since the stupid fucking subcon requirements
    return ret.toNumber();
    // uncomment the above when need for negative claim subcon
    // return 0;
  } else {
    let currTotalRet = ret.plus(reSumRet);
    if (currTotalRet.gt(reMaxRet) && reSumRet.lt(reMaxRet)) {
      returnVal = reMaxRet.minus(reSumRet);
      return returnVal.toNumber();
    } else if (currTotalRet.gt(reMaxRet)) {
      return 0;
    } else {
      return ret.toNumber();
    }
  }
};

export const subtotal = data => {
  return (
    new BigNumber(data.gTotal || 0)
      .plus(data.daywork || 0)
      .minus(data.retAmt || 0)
      // .minus(data.currDeduction || 0)
      .toNumber()
  );
};

export const subtotalApprove = data => {
  return (
    new BigNumber(data.gTotal || 0)
      .plus(data.daywork || 0)
      .minus(data.retAmt || 0)
      // .minus(data.advRecoupment || 0)
      // .minus(data.deduction || 0)
      .toNumber()
  );
};

export const netReceivable = data => {
  return new BigNumber(data.totalAmt || 0).toNumber();
};

export const taxRate = data => {
  return new BigNumber(data.taxRate).div(100).toNumber();
};

export const taxAmt = data => {
  // if !taxChangeableNeeded then taxRate === 1, later
  return new BigNumber(data.val)
    .times(data.taxRate === 0 ? 0 : data.taxRate || 1)
    .toNumber();
};

export const taxDisplay = data => {
  return new BigNumber(data || 0).times(100).toNumber();
};

const totalAmtApprove = data => {
  return new BigNumber(data.subTotal || 0)
    .minus(data.advRecoupment || 0)
    .minus(data.deduction || 0)
    .toNumber();
};

/////////////////////////////////////////////////////
/////////// INPUT PART //////////////////////////////
/////////////////////////////////////////////////////

export const calc = (data, type) => {
  const {
    currAmt,
    VOClaim,
    prevClaim,
    prevVo,
    currMOS,
    prevMOS,
    progRet,
    maxRet,
    prevRetSum,
    daywork,
    inputRetention,
    currDeduction,
    taxRate: rate,
    totalTaxAmount,
    retAmt,
    advRecoupment,
    conSubconType,
    subconClaimAllocation,
    excludeVO,
    isTaxEdited,
    taxAmount,
    formMode,
    totalSubmissionTax,
    totalSubmissionVoTax,
  } = data;

  const totalClaim = netClaim({
    currAmt,
    VOClaim,
    prevClaim,
    prevVo,
  });

  const totalClaimWoVO = netClaim({
    currAmt,
    VOClaim: 0,
    prevClaim,
    prevVo: 0,
  });

  const totalMOS = netMOS({ currMOS, prevMOS });

  const grossTotal = gTotal({ netClaim: totalClaim, netMOS: totalMOS });
  const grossTotalWoVO = gTotal({ netClaim: totalClaimWoVO, netMOS: totalMOS });
  const grossTotalWOMos = gTotal({ netClaim: totalClaim, netMOS: 0 });

  // const retention = ret({
  //   maxRet: maxRet,
  //   prevRetSum: prevRetSum,
  //   gTotal: data?.excludeVO ? grossTotalWoVO : grossTotal,
  //   // gTotal: grossTotalWOMos,
  //   progRet,
  // });

  let currentRetention = ret({
    maxRet: maxRet,
    prevRetSum: prevRetSum,
    gTotal: excludeVO ? grossTotalWoVO : grossTotal,
    // gTotal: grossTotalWOMos,
    progRet,
  });

  const recalRet = calcRet({
    maxRet: maxRet,
    prevRetSum: prevRetSum,
    ret: type === 'approve' ? currentRetention : retAmt,
  });

  let subTotal = 0;
  const subTotalSub = subtotal({
    gTotal: grossTotal,
    daywork,
    retAmt: !!inputRetention ? inputRetention : retAmt,
    // retCalc: recalRet.toFixed(2),
    // currDeduction,
  });

  const subTotalAppr = subtotalApprove({
    gTotal: grossTotal,
    daywork,
    // retAmt: inputRetention ?? retAmt,
    retAmt:
      parseFloat(inputRetention) !== 0 && inputRetention !== undefined
        ? inputRetention
        : retAmt,
    //retAmt: recalRet.toFixed(2),
    // advRecoupment,
    // deduction: currDeduction,
  });

  subTotal =
    type === 'submit'
      ? new BigNumber(subTotalSub.toFixed(2)).toNumber()
      : new BigNumber(subTotalAppr.toFixed(2)).toNumber();

  // please allow this to finished CX-2684 issues
  // console.log("sini ==>", formMode, "==", isTaxEdited, "==", totalTaxAmount);
  // const taxamt =
  //   formMode === 'add' && !isTaxEdited
  //     ? 0
  //     : isTaxEdited
  //       ? taxAmount
  //       : totalTaxAmount;

  const taxamt = isTaxEdited ? taxAmount : totalTaxAmount;
  // const taxamt =
  //   isTaxEdited
  //     ? taxAmount
  //     : type === 'approve'
  //       ? new BigNumber(grossTotal)
  //         .minus(retAmt)
  //         .plus(daywork)
  //         .times(rate)
  //         .dividedBy(100)
  //         .toNumber()
  //       : totalTaxAmount;

  // const taxrate = taxRate({ taxRate: rate });
  //
  // const taxamt = taxAmt({ val: subTotal, taxRate: taxrate });

  // console.log(taxrate, 'taxrate');
  //// submit - deduction is not taxed
  //// approved - deduction & advance-recoupment are not taxed
  const totalAmount =
    type === 'submit'
      ? simpleMinus({
          data1: simplePlus({
            data1: subTotal,
            data2: isTaxEdited ? taxAmount : taxamt,
          }),
          data2: currDeduction,
        })
      : totalAmtApprove({
          subTotal: simplePlus({
            data1: subTotal,
            data2: isTaxEdited ? taxAmount : taxamt,
          }),
          advRecoupment,
          deduction: currDeduction,
        });

  const totalTaxSubmission = simplePlus({
    data1: totalSubmissionTax,
    data2: totalSubmissionVoTax,
  });

  // const totalAmount = simplePlus({
  //   data1: subTotal,
  //   data2: taxamt,
  // });

  return {
    totalClaim,
    totalClaimWoVO,
    totalMOS,
    grossTotal,
    grossTotalWoVO,
    // retention: currentRetention,
    retention:
      parseFloat(inputRetention) !== 0
        ? parseFloat(inputRetention)
        : currentRetention,
    recalRet,
    subTotal,
    // taxrate,
    taxamt,
    totalAmount,
    totalTaxSubmission,
  };
};

export const toFloat = (data: string) => {
  return parseFloat(amtNumStr(data));
};

export const toFloatCond = (data: any) => {
  if (typeof data === 'string') {
    return parseFloat(amtNumStr(data));
  } else {
    return data;
  }
};

////////// interface   ///////////

//// ......... submit ............ ////
export interface IProgressClaim {
  consubconID: string;
  date: Date;
  submissionAmt: number;
  voClaim: number;
  daywork: number;
  retention: number;
  deduction: number;
  MOSSubmission: number;
  taxRate: number;
  docRefNo: string;
  taxSchemeID: string;
  description: string;
  ledgerData: any;
  eInvoiceMsicCodeID: any;
  currencyID: string;
  exchangeRate: number;
}

export interface IProgressSubconClaim {
  consubconID: string;
  date: Date;
  submissionAmt: number;
  voClaim: number;
  daywork: number;
  deduction: number;
  MOSSubmission: number;
  taxRate: number;
  taxSchemeID: string;
  docRefNo: string;
  description: string;
  taxInvNo: string;
  ledgerData: any;
  eInvoiceMsicCodeID: any;
  eInvoiceSelfBilledDate?: Date;
  currencyID: string;
  exchangeRate: number;
}

//// ......... approve ............ ////

export interface IApproveClaim {
  approveAmt: number;
  approveVO: number;
  MOSApprove: number;
  retention: number;
  daywork: number;
  advRecoupment: number;
  deduction: number;
  docRefNo: string;
  taxRate: number;
  ledgerData: any;
  contractSubmissionVO: any;
  eInvoiceMsicCodeID: any;
  eInvoiceSelfBilledDate?: Date;
  currencyID: string;
  exchangeRate: number;
}

//////// yup ////////////

export const claimYup = (opts: any) => {
  return yup.object().shape({
    // taxRate: !opts?.implementWbs
    //   ? CommonYupValidation.requireField('Tax Rate is required')
    //   : null,
    // date: opts?.minDate ? yup
    //   .date().required('Please select a claim date')
    //   .min(opts?.minDate, 'Date cannot be earlier than previous claim date')
    //   : null,
    description: CommonYupValidation.requireField(SystemMsgs.description()),
    eInvoiceMsicCodeID: opts?.validateEinvoice
      ? yup
          .object()
          .required('MSIC Code is required')
          .nullable()
      : null,
    currencyID: !!opts?.isCurrency
      ? CommonYupValidation.requireField(SystemMsgs.currency())
      : null,
    exchangeRate: !!opts?.isCurrency
      ? yup
          .number()
          .required(SystemMsgs.currencyRate())
          .min(0.01, 'The rate must be at least 0.00000001')
      : null,
  });
};

export const SubconClaimYup = (opts: any) => {
  return yup.object().shape({
    // taxRate: !opts?.implementWbs
    //   ? CommonYupValidation.requireField('Tax Rate is required')
    //   : null,
    taxInvNo: CommonYupValidation.requireField('Tax Invoice No. is required'),
    description: CommonYupValidation.requireField(SystemMsgs.description()),
    eInvoiceSelfBilledDate: opts?.validateEinvoice
      ? CommonYupValidation.requireField('Self-Billed Date is required')
      : null,
    eInvoiceMsicCodeID: opts?.validateEinvoice
      ? yup
          .object()
          .required('MSIC Code is required')
          .nullable()
      : null,
    exchangeRate: !!opts?.multiCurrencySubscriber
      ? yup
          .number()
          .required(SystemMsgs.currencyRate())
          .min(0.01, 'The rate must be at least 0.00000001')
      : null,
  });
};

////// handle pdf prev (submit) /////////////

export const handlePDFPreview = claimData => {
  let data = {};

  data['ID'] = claimData?.ID;
  data['transactionID'] = claimData?.transactionID;
  data['account'] = claimData?.account;
  data['accountType'] = claimData?.accountType;
  data['accountTypeData'] = claimData?.accountTypeData;
  data['transaction'] = claimData?.transaction;
  data['transactionType'] = claimData?.transactionType;
  data['conSubcon'] = claimData?.selectedContract;
  data['maxRetention'] = claimData?.maxRetention;
  data['totalVOSum'] = claimData?.totalVOAmt;
  data['revisedContractSum'] =
    claimData?.accountType === 'client-account'
      ? claimData?.revisedContractSum
      : claimData?.revisedSubcontractSum;
  data['input'] = input(claimData, claimData?.file);
  data['formMode'] = claimData?.form;
  data['isMultipleTradeAndSubcontract'] =
    claimData?.isMultipleTradeAndSubcontract ?? false;
  data['implementWbs'] = claimData?.implementWbs ?? false;
  // claimData?.form === 'Draft' || claimData?.form === 'Resubmit'
  //   ? input(claimData, claimData?.file)
  //   : input(claimData, claimData?.file);

  return data;
};

const input = (claimData, file) => {
  const data = claimData.data;
  const ID = claimData.transactionID;

  return Object.assign(
    inputGeneral(claimData, file, ID),
    detailInput(claimData.detailData, claimData?.exchangeRate),
    conSubconInput(data, claimData.accountType),
  );
};

const inputGeneral = (data, file, ID?) => {
  const { data: claimData, contractID }: any = data;
  return {
    ...(ID ? { ID: ID } : null),
    description: claimData?.description,
    taxSchemeID: claimData?.taxSchemeID,
    contractID: contractID,
    submittedDate: claimData?.date,
    docRef: claimData?.docRefNo,
    file: file,
    docDueDate: data?.docDueDate,
    miscTaxItem: data?.miscTaxItem,
    eInvoiceMsicCodeID: claimData?.eInvoiceMsicCodeID?.id ?? null,
    ...(data?.accountType === 'subcontractor-account'
      ? {
          eInvoiceSelfBilled: data?.eInvoiceSelfBilled,
          eInvoiceSelfBilledDate: data?.eInvoiceSelfBilled
            ? claimData?.eInvoiceSelfBilledDate
            : null,
        }
      : {}),
    ...(data?.accountType === 'client-account'
      ? {
          isEInvoice: data?.isEInvoice,
          eInvoiceDirectSend: data?.isEInvoice
            ? data?.eInvoiceDirectSend
            : false,
        }
      : {}),
    currencyID: claimData?.currencyID,
    exchangeRate: claimData?.exchangeRate,
  };
};

const conSubconInput = (data, accountType) => {
  const {
    contractID,
    consubconID,
    customerID,
    subcontractID,
    subcontractorID,
    taxInvNo,
    contractSubmissionAlloc,
    contractSubmissionVO,
    subconSubmissionAlloc,
    subconSubmissionVO,
    currencyID,
    exchangeRate,
  } = data;

  if (accountType === 'client-account') {
    return {
      ...(contractSubmissionVO?.length > 0
        ? {
            voAlloc: contractSubmissionVO?.filter(
              v => v?.currentSubmission !== 0 && !!v?.currentSubmission,
            ),
          }
        : {}),
      ...(contractSubmissionAlloc?.length > 0
        ? {
            claimAlloc: contractSubmissionAlloc?.filter(
              v => v?.currentSubmission !== 0 && !!v?.currentSubmission,
            ),
          }
        : {}),
      customerID: customerID,
      currencyID: currencyID,
      exchangeRate: exchangeRate,
    };
  } else {
    return {
      ...(subconSubmissionVO?.length > 0
        ? {
            voAlloc: subconSubmissionVO?.filter(
              v => v?.currentSubmission !== 0 && !!v?.currentSubmission,
            ),
          }
        : {}),
      ...(subconSubmissionAlloc?.length > 0
        ? {
            claimAlloc: subconSubmissionAlloc?.filter(
              v => v?.currentSubmission !== 0 && !!v?.currentSubmission,
            ),
          }
        : {}),
      subcontractID: consubconID ?? subcontractID,
      subcontractorID: subcontractorID,
      contractID: contractID,
      docNo: taxInvNo,
      currencyID: currencyID,
      exchangeRate: exchangeRate,
    };
  }
};

const detailInput = (data, exchangeRate) => {
  return {
    transactionStatus: data.transactionStatus,
    submittedCertifiedAmt: data.currentSubmissionAmt,
    submittedVOClaimAmt: data.VOClaim,
    submittedMosAmt: data.currentMOSSubmissionAmt,
    submittedDayWorkAmt: data.daywork,
    submittedDeductionAmt: data.currentSubmissionDeduction,
    submittedMosRetentionAmt: data.submittedMosRetentionAmt,
    retentionAmt: data.retention,
    submittedRetentionAmt: data.submittedRetentionAmt,
    balanceRetentionAmt: data.balanceRetentionAmt,
    baseAmt: data.totalAmount,
    localBaseAmt: data.totalAmount * exchangeRate,
    previousCertifiedAmt: data.previousClaim,
    previousVOClaimAmt: data.previousVOClaim,
    previousMosAmt: data.previousMOS,
    taxAmt: data.taxAmt,
    localTaxAmt: data.taxAmt * exchangeRate,
    taxRate: data.taxRate,
    deductionLedger: data.deductionLedger,
    voDisplayAmt: data.voDisplayAmt,
    mosTaxAmt: data.mosTaxAmt,
    dayworkTaxAmt: data.dayworkTaxAmt,
  };
};

////// handle pdf prev (approve) /////////////

export const handlePDFApprovePreview = claimData => {
  let data = {};

  data['ID'] = claimData?.ID;
  data['transactionID'] = claimData?.transactionID;
  data['account'] = claimData?.account;
  data['accountType'] = claimData?.accountType;
  data['transaction'] = claimData?.transaction;
  data['transactionType'] = claimData?.transactionType;
  data['conSubcon'] = claimData?.selectedContract;
  data['maxRetention'] = claimData?.maxRetention;
  data['totalVOSum'] = claimData?.totalVOAmt;
  data['revisedContractSum'] =
    claimData?.accountType === 'client-account'
      ? claimData?.revisedContractSum
      : claimData?.revisedSubcontractSum;
  data['onUpdateInput'] = onUpdateInput(claimData, claimData.file);
  data['submittedDate'] = claimData?.submittedDate;
  data['approvedDate'] = new Date(claimData?.approvedDate).toString();
  data['isMultipleTradeAndSubcontract'] =
    claimData?.isMultipleTradeAndSubcontract ?? false;
  data['implementWbs'] = claimData?.implementWbs ?? false;
  return data;
};

const onUpdateInput = (claimData, file) => {
  const data = claimData.data;
  const ID = claimData.transactionID;

  return Object.assign(
    inputGenAppr(data, file, ID),
    detailInputAppr(claimData.detailData, claimData?.exchangeRate),
    conSubconApprInput(data, claimData.accountType),
  );
};

const conSubconApprInput = (data, accountType) => {
  const {
    contractID,
    customerID,
    subcontractID,
    subcontractorID,
    taxInvNo,
    contractSubmissionAlloc,
    contractSubmissionVO,
    subconSubmissionAlloc,
    subconSubmissionVO,
    currencyID,
    exchangeRate,
  } = data;

  if (accountType === 'client-account') {
    return {
      ...(contractSubmissionVO?.length > 0
        ? {
            voAlloc: contractSubmissionVO?.filter(v => {
              return (
                v?.currentSubmission !== 0 && v?.currentSubmission !== undefined
              );
            }),
          }
        : {}),
      ...(contractSubmissionAlloc?.length > 0
        ? {
            claimAlloc: contractSubmissionAlloc?.filter(v => {
              return (
                v?.currentSubmission !== 0 && v?.currentSubmission !== undefined
              );
            }),
          }
        : {}),
      customerID: customerID,
      currencyID: currencyID,
      exchangeRate: exchangeRate,
    };
  } else {
    return {
      ...(subconSubmissionVO?.length > 0
        ? {
            voAlloc: subconSubmissionVO?.filter(v => {
              return (
                v?.currentSubmission !== 0 && v?.currentSubmission !== undefined
              );
            }),
          }
        : {}),
      ...(subconSubmissionAlloc?.length > 0
        ? {
            claimAlloc: subconSubmissionAlloc?.filter(v => {
              return (
                v?.currentSubmission !== 0 && v?.currentSubmission !== undefined
              );
            }),
          }
        : {}),
      contractID: contractID,
      subcontractID: subcontractID, // this is wrong
      subcontractorID: subcontractorID,
      docNo: taxInvNo,
      currencyID: currencyID,
      exchangeRate: exchangeRate,
    };
  }
};

const inputGenAppr = (data, file, ID) => {
  return {
    ID: ID,
    description: data.description,
    taxSchemeID: data.taxSchemeID,
    contractID: data.consubconID,
    // docDate: data.approvedDate,
    docDate: formatDateToYmd(data.approvedDate),
    docDueDate: data.dueDate,
    docRef: data.docRefNo,
    file: file,
    miscTaxItem: data?.miscTaxItem,
    eInvoiceMsicCodeID: data.eInvoiceMsicCodeID?.id ?? null,
    ...(data?.accountType === 'subcontractor-account'
      ? {
          eInvoiceSelfBilled: data?.eInvoiceSelfBilled,
          eInvoiceSelfBilledDate: data?.eInvoiceSelfBilled
            ? data?.eInvoiceSelfBilledDate
            : null,
        }
      : {}),
    ...(data?.accountType === 'client-account'
      ? {
          isEInvoice: data?.isEInvoice,
          eInvoiceDirectSend: data?.isEInvoice
            ? data?.eInvoiceDirectSend
            : false,
        }
      : {}),
    currencyID: data?.currencyID,
    exchangeRate: data?.exchangeRate,
  };
};

const detailInputAppr = (data, exchangeRate) => {
  return {
    transactionStatus: data.transactionStatus,
    currentCertifiedAmt: data.approvedClaim,
    currentVOClaimAmt: data.approvedVOClaim,
    currentMosAmt: data.currentApprovedMOS,
    currentDayWorkAmt: data.approvedDaywork,
    currentDeductionAmt: data.deduction,
    currentAdvBalance: data.advanceBalance,
    currentAdvRecoupmentAmt: data.advanceRecoupment,
    currentMosRetentionAmt: data.approvedMosRetentionAmt,
    docNo: data.docNo,
    retentionAmt: data.retention,
    baseAmt: data.totalAmount,
    localBaseAmt: data.totalAmount * exchangeRate,
    previousCertifiedAmt: data.previousClaim,
    previousVOClaimAmt: data.previousVO,
    previousMosAmt: data.previousMOS,
    taxAmt: data.taxAmt,
    localTaxAmt: data.taxAmt * exchangeRate,
    outstandingAmt: data.outstandingAmt,
    taxRate: data.taxRate,
    deductionLedger: data.deductionLedger,
    voDisplayAmt: data.voDisplayAmt,
    mosTaxAmt: data.approvedMosTaxAmt,
    dayworkTaxAmt: data.approvedDayworkTaxAmt,
  };
};

//////// claim deduction ledger ////////////

export const initializedDeductionLedger = ({ allocationData, accountType }) => {
  let ledgerData = [];

  allocationData?.map(v => {
    if (accountType === 'client-account') {
      ledgerData?.push({
        creditID: v?.ID,
        creditRefTable: v?.docRefTable,
        allocationAmt: parseFloat(v?.allocatedByDoc),
        taxRate: v?.taxRate,
      });
    } else {
      ledgerData?.push({
        debitID: v?.ID,
        debitRefTable: v?.docRefTable,
        allocationAmt: parseFloat(v?.allocatedByDoc),
        taxRate: v?.taxRate,
      });
    }
  });

  return ledgerData;
};

export const claimTotalAmt = (data: any, status: any) => {
  let totalAmt = 0;
  let netAmt;
  if (status === 'APPROVED') {
    netAmt =
      data?.currentCertifiedAmt +
      data?.currentVOClaimAmt +
      data?.currentMosAmt -
      data?.previousCertifiedAmt -
      data?.previousVOClaimAmt -
      data?.previousMosAmt -
      data?.retentionAmt +
      data?.taxAmt -
      data?.currentAdvRecoupmentAmt;
    totalAmt = netAmt;
  } else {
    netAmt =
      data?.submittedCertifiedAmt +
      data?.submittedVOClaimAmt +
      data?.submittedMosAmt -
      data?.previousCertifiedAmt -
      data?.previousVOClaimAmt -
      data?.previousMosAmt -
      data?.retentionAmt +
      data?.taxAmt;
    totalAmt = netAmt;
  }
  return totalAmt;
};

//CX-5433
export const formatDateToYmd = (value: string | Date | null | undefined) => {
  if (!value) return '';

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  return date.toISOString().slice(0, 10);
};
